/**
 * @title App
 * @description Application entry point
 */

// Jquery
import wineDetail from "./components/wine-detail";

window.jQuery = $;
window.$ = $;
jQuery = $;

// Barba - pages transition
import barba from "@barba/core";
import barbaCss from "@barba/css";

import Flickity from "flickity";
import "flickity/css/flickity.css";

require("flickity-fade");
require("flickity-bg-lazyload");
require("flickity-as-nav-for");
require('flickity-imagesloaded');

// Modal
import modal from "jquery-modal";

// Lazyload image
import LazyLoad from "vanilla-lazyload";

// Components
import spinner from "./components/spinner";
import mapEnogea from "./components/map-enogea";
import newsletter from "./components/newsletter";
import clubArea from "./components/club-area";
import postFormTo from "./components/post-form";
import cellarVisit from "./components/cellar-visit";

// Form validation
require('jquery-form');
require('jquery-validation');
require('jquery-validation-unobtrusive');
require('jquery.redirect');

var imagesLoaded = require("imagesloaded");
require("jquery.resizeend");

import hoverIntent from "jquery-hoverintent";
import SimpleBar from 'simplebar';

// Modules
import navbar from "../modules/navbar/navbar";
import thomDropdown from "../modules/dropdown/dropdown";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video"
import lgZoom from "lightgallery/plugins/zoom"

import Hls from "hls.js/dist/hls.min";

// exist element
$.fn.exists = function () {
    return this.length !== 0;
};

gsap.config({
    nullTargetWarn: false
});

// Modal default options
$.modal.defaults = {
    clickClose: true,
    escapeClose: true,
    fadeDuration: 250,
    fadeDelay: 1.1,
    showClose: false,
    spinnerHtml: '<div id="spinner" class="default"><div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div></div>',
    blockerClass: "jquery-modal"
}

const deviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }
    return "desktop";
};

let makeTabs = (el, callback) => {
    var $this = $(el);
    var nav = $this.find('.tabs--nav');
    var navItem = nav.find('.item');
    var contents = $this.find('.tabs--content');
    var contentsItem = contents.find('.item');
    var tabSelected = nav.find('.selected');
    var tabH = 0;

    let resizeTabsContent = () => {
        // gsap.set(contentsItem,{duration: 0.01, display: 'block'})
        contentsItem.each(function () {
            var h = $(this).height();
            if (h > tabH) {
                tabH = h;
            }
        });
        contents.height(tabH);
    }

    if (callback && deviceType() !== "mobile") {
        contentsItem.css('display', 'block');
        resizeTabsContent();
        $(window).on("resizeend", 250, function () {
            resizeTabsContent();
        });
    }

    if (tabSelected.length <= 0) {
        tabSelected = navItem.first();
    }

    let openTab = (current) => {
        navItem.removeClass('selected');
        //
        // contentsItem.hide();

        navItem.eq(current).addClass('selected');
        // contentsItem.eq(current).show();
        if (matchMedia('screen and (min-width: 768px)').matches) {
            gsap.to(contentsItem, {
                duration: 0.25, autoAlpha: 0, height: 0, display: 'none', delay: 0.15, onComplete: function () {
                    gsap.to(contentsItem.eq(current), {
                        duration: 0.25,
                        height: 'auto',
                        autoAlpha: 1,
                        display: 'block',
                        delay: 0.15
                    });
                }
            });
        } else {
            gsap.to(contentsItem, {
                duration: 0.25, autoAlpha: 1, height: 'auto', display: 'none', delay: 0.15, onComplete: function () {
                    gsap.to(contentsItem.eq(current), {
                        duration: 0.25,
                        height: 'auto',
                        autoAlpha: 1,
                        display: 'block',
                        delay: 0.15
                    });
                }
            });
        }

    }

    navItem.on('click', function (e) {
        e.preventDefault();
        var tabIndex = $(this).index();
        openTab(tabIndex);
    });

    openTab(tabSelected.index())
}

var myLazyLoad;

// Start APP
function myapp() {
    var callback_loaded = function (element) {
        if ($(element).parents('.modal-art-photogallery').length) {
            gsap.to(element, {scale: 1, autoAlpha: 1, ease: "power1.inOut"})
        }
    };

    var initVideoModal = function ($objs) {
        if ($objs.exists()) {
            $objs.each(function (){
                var $this = $(this);
                lightGallery($this[0], {
                    mode: 'lg-fade',
                    zoomFromOrigin: false,
                    selector: 'this',
                    download: false,
                    counter: false,
                    width: "80%",
                    iframeWidth: "80%",
                    getCaptionFromTitleOrAlt: false,
                    youtubePlayerParams: {
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0,
                        controls: 0,
                    },
                    vimeoPlayerParams: {
                        byline: 0,
                        portrait: 0,
                    },
                    plugins: [lgVideo],
                });
            })
        }
    }

    $('img')
        .on('dragstart', function (event) {
            event.preventDefault();
        })
        .on('contextmenu', function (e) {
            return false;
        });

    myLazyLoad = null;
    myLazyLoad = new LazyLoad({
        unobserve_entered: true,
        elements_selector: ".lazy",
        callback_loaded: callback_loaded,
    });

    // Fade in animation
    const animFadeInEl = gsap.utils.toArray('.anim__fadeIn');
    // Set things up
    gsap.set(animFadeInEl, {autoAlpha: 0, yPercent: 5});
    animFadeInEl.forEach((el, i) => {
        // Set up your animation
        const animFadeInAnim = gsap.to(el, {duration: 1, autoAlpha: 1, yPercent: 0, paused: true});
        // Use callbacks to control the state of the animation
        ScrollTrigger.create({
            trigger: el,
            start: "top 90%",
            end: "bottom 90%",
            once: true,
            // markers: true,
            onEnter: self => {
                // If it's scrolled past, set the state
                // If it's scrolled to, play it
                self.progress === 1 ? animFadeInAnim.progress(1) : animFadeInAnim.play()
            }
        });
    });

    // Scroll Up in animation
    const animScrollUpEl = gsap.utils.toArray('.anim__scrollUp');
    ScrollTrigger.matchMedia({
        "(min-width:640px)": function () {
            animScrollUpEl.forEach((el, i) => {
                let animScrollUpTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: "top bottom",
                        end: "bottom 8%",
                        scrub: 0.5,
                        // markers: true
                    }
                });
                animScrollUpTl.to(el, {
                    yPercent: -5,
                    ease: "power1.inOut"
                })
            });
        }
    })

    // Scroll Down in animation
    const animScrollDownEl = gsap.utils.toArray('.anim__scrollDown');
    ScrollTrigger.matchMedia({
        "(min-width:640px)": function () {
            animScrollDownEl.forEach((el, i) => {
                let animScrollDownTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: "top bottom",
                        end: "bottom 8%",
                        scrub: 1,
                        // markers: true
                    }
                });
                animScrollDownTl.to(el, {
                    yPercent: 5,
                    ease: "power1.inOut"
                })
            });
        }
    })

    // Image ZoomIn animation
    const animZoomInEl = gsap.utils.toArray('.anim__zoomIn');
    animZoomInEl.forEach((el, i) => {
        let animZoomInTl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: "center bottom",
                end: "center top",
                scrub: 1,
                // markers: true
            }
        });
        animZoomInTl.to(el, {
            scale: 1.1,
            ease: "power1.inOut"
        })
    });

    // Image ZoomOut animation
    const animZoomOutEl = gsap.utils.toArray('.anim__zoomOut');
    gsap.set(animZoomOutEl, {scale: 1.1});
    animZoomOutEl.forEach((el, i) => {
        let animZoomOutTl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: "center bottom",
                end: "center top",
                scrub: 1,
                // markers: true
            }
        });
        animZoomOutTl.to(el, {
            scale: 1,
            ease: "power1.inOut"
        })
    });

    // section video / Scrolltrigger
    if ($('.section--video').exists() && $('.section--video').hasClass('section--intro')) {
        $('.section--video').each(function () {
            var $this = $(this);

            if ($this.find(".section--video__item").length > 0) {
                var videoElement = $this.find(".section--video__item")[0];
                let videoSrc = $this.find(".section--video__item").data('src');

                if (Hls.isSupported() && videoSrc.split(/[#?]/)[0].split('.').pop().trim() === 'm3u8') {
                    var hls = new Hls({
                        //debug: true
                    });
                    hls.loadSource(videoSrc);
                    hls.attachMedia(videoElement);
                    hls.on(Hls.Events.MANIFEST_LOADED, function () {
                        $this.addClass('is-playing');
                        videoElement.play();
                        blurredBackdrop($this, videoElement);
                    });
                } else {
                    videoElement.src = videoSrc;
                    videoElement.load();
                    videoElement.addEventListener('canplay', (e) => {
                        $this.addClass('is-playing');
                        videoElement.play();
                        blurredBackdrop($this, videoElement);
                    });
                }

                // Hide video text on scroll
                if ($this.find(".section--video__text").exists()) {
                    ScrollTrigger.matchMedia({
                        "(min-width:640px)": function () {
                            var videoText_tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: $this.find(".section--video__text"),
                                    start: "top 0",
                                    end: "center 5%",
                                    scrub: 0.5,
                                    // markers: true
                                }
                            });
                            videoText_tl.to($this.find(".section--video__text .anim"), {
                                // yPercent: 60,
                                autoAlpha: 0,
                                ease: "power1.inOut"
                            }, "-=1")
                        }
                    })
                }
            }

            function blurredBackdrop($this, videoElement) {

                if ($(".blur-backdrop").exists()) {
                    let blurBackdrop = document.querySelector('.blur-backdrop');

                    var pageTl = gsap.timeline({
                        scrollTrigger: {
                            trigger: $('.blurred-backdrop-el'),
                            start: "bottom 80%",
                            end: "bottom 30%",
                            scrub: 1,
                            // markers: true,
                            onEnterBack: function (e) {
                                $this.addClass('is-playing');
                                videoElement.play();
                            },
                            onLeave: function (e) {
                                $this.removeClass('is-playing');
                                videoElement.pause();
                            },
                        }
                    });
                    pageTl.to(blurBackdrop, {
                        autoAlpha: 1,
                        ease: "power1.inOut"
                    })
                }
            }

        });
    }

    // video media / Scrolltrigger
    if ($('.media-video').exists()) {
        $('.media-video').each(function () {
            var $this = $(this);
            var videoElement = $this.find(".video")[0];
            let videoSrc = $this.find(".video").data('src');
            let videoReadyState;

            if (Hls.isSupported()) {
                var hls = new Hls();
                hls.loadSource(videoSrc);
                hls.attachMedia(videoElement);
                hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                    videoReadyState = 3;
                });
            } else {
                videoElement.src = videoSrc;
                videoElement.load();
                videoElement.addEventListener('canplay', (e) => {
                    videoReadyState = 3;
                });
            }

            let itemOnEnter = () => {
                if (videoReadyState >= 3) {
                    $this.addClass('is-playing');
                    videoElement.play();
                }
            }
            let itemOnLeave = () => {
                $this.removeClass('is-playing');
                videoElement.pause();
            }

            var mediaTl = gsap.timeline({
                scrollTrigger: {
                    trigger: $this[0],
                    start: "top 80%",
                    end: "bottom 10%",
                    // markers: true,
                    onEnter: function () {
                        itemOnEnter()
                    },
                    onEnterBack: function () {
                        itemOnEnter()
                    },
                    onLeave: itemOnLeave,
                    onLeaveBack: itemOnLeave,
                }
            });
        })
    }

    // Home Hospitality
    if ($('.horizontal-continuous-slider').exists()) {
        const horizontalContinuousSlider = document.querySelector('.horizontal-continuous-slider');
        let flickityHorizontalAutoscrollTickerSpeed = 1;
        let flickityHorizontalAutoscroll = null;
        const flickityHorizontalAutoscrollEl = horizontalContinuousSlider.querySelector('.js-slideshow');
        var myReq;
        const flickityHorizontalAutoscrollInit = () => {
            const flickityHorizontalAutoscrollUpdate = () => {
                if (flickityHorizontalAutoscroll.slides) {
                    flickityHorizontalAutoscroll.x = (flickityHorizontalAutoscroll.x - flickityHorizontalAutoscrollTickerSpeed) % flickityHorizontalAutoscroll.slideableWidth;
                    flickityHorizontalAutoscroll.selectedIndex = flickityHorizontalAutoscroll.dragEndRestingSelect();
                    flickityHorizontalAutoscroll.updateSelectedSlide();
                    flickityHorizontalAutoscroll.settle(flickityHorizontalAutoscroll.x);
                }
                myReq = window.requestAnimationFrame(flickityHorizontalAutoscrollUpdate);
            };

            flickityHorizontalAutoscroll = new Flickity(flickityHorizontalAutoscrollEl, {
                autoPlay: false,
                prevNextButtons: false,
                pageDots: false,
                draggable: false,
                wrapAround: true,
                freeScroll: true,
                freeScrollFriction: 0.03,
                imagesLoaded: true
            });
            flickityHorizontalAutoscroll.x = 0;
            if (deviceType() === "mobile" && $(flickityHorizontalAutoscrollEl).hasClass('stop-mobile')) {

            } else {
                flickityHorizontalAutoscrollUpdate();
            }
        }

        let imgs = flickityHorizontalAutoscrollEl.querySelectorAll('img');
        let len = imgs.length;
        let counter = 0;

        [].forEach.call(imgs, function (img) {

            if (img.complete) {
                var myW = img.width;
                img.parentElement.style.width = myW + 'px';
                incrementCounter();
            } else {
                img.addEventListener('load', incrementCounter, false);
            }
        });

        function incrementCounter() {
            counter++;
            if (counter === len) {
                flickityHorizontalAutoscrollInit();
            }
        }
    }

    // Wines category
    if ($('.wines-category--item').exists()) {
        let wiesCat = document.querySelector('.wines-category');
        let catItems = wiesCat.querySelectorAll('.wines-category--item');
        let imgs = wiesCat.querySelectorAll('img');
        let len = imgs.length;
        let counter = 0;
        var interval = 500;

        [].forEach.call(imgs, function (img) {
            if (img.complete) {
                incrementCounter();
            } else {
                img.addEventListener('load', incrementCounter, false);
            }
        });

        function task(i) {
            setTimeout(function () {
                catItems[i].classList.add("show");
            }, interval * i);
        }

        function incrementCounter() {
            counter++;
            if (counter === len) {
                for (let i = 0; i < len; i++) {
                    task(i);
                }

                $('.wines-category--item').each(function () {
                    var $this = $(this);
                    if ($this.find(".video").length > 0) {
                        var videoElement = $this.find(".video")[0];
                        let videoSrc = $this.find(".video").data('src');
                        let videoReadyState;

                        if (Hls.isSupported()) {
                            var hls = new Hls();
                            hls.loadSource(videoSrc);
                            hls.attachMedia(videoElement);
                            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                                videoReadyState = 3;
                            });
                        } else {
                            videoElement.src = videoSrc;
                            videoElement.load();
                            videoElement.addEventListener('loadeddata', (e) => {
                                videoReadyState = videoElement.readyState;
                            });
                        }

                        let itemOnEnter = () => {
                            // if(videoReadyState >= 3){
                            $this.addClass('is-playing');
                            videoElement.play();
                            // }
                        }
                        let itemOnLeave = () => {
                            $this.removeClass('is-playing');
                            videoElement.pause();
                        }
                        if (deviceType() === "mobile" || deviceType() === "tablet") {
                            if ($this.index() == 0) {
                                $this.addClass('is-playing');
                                videoElement.play();
                            }
                            var videoElementTl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: $this[0],
                                    start: "center 80%",
                                    end: "center 10%",
                                    // markers: true,
                                    onEnter: function () {
                                        itemOnEnter()
                                    },
                                    onEnterBack: function () {
                                        itemOnEnter()
                                    },
                                    onLeave: itemOnLeave,
                                    onLeaveBack: itemOnLeave,
                                }
                            });
                        } else {
                            $this.hoverIntent({
                                over: itemOnEnter,
                                out: itemOnLeave
                            });
                        }
                    }
                });
            }
        }
    }

    // Wines List
    if ($('.wines-list--cat').exists()) {
        gsap.utils.toArray('.wines-list--cat').forEach(category => {
            var imgs = category.querySelectorAll('.wines-list--images .item');
            var links = category.querySelectorAll('.wines-list--links .item');
            ScrollTrigger.matchMedia({
                "(min-width:640px)": function () {
                    ScrollTrigger.create({
                        trigger: category,
                        start: "top top",
                        end: "bottom bottom",
                        pin: category.querySelector('.col-sidebar'),
                        // markers: true
                    });

                    let itemOnEnter = (img) => {
                        var id = img.dataset.wine;
                        category.querySelector('#' + id).classList.add('show');
                    }
                    let itemOnLeave = (img) => {
                        var id = img.dataset.wine;
                        category.querySelector('#' + id).classList.remove('show');
                    }

                    gsap.utils.toArray(imgs).forEach(img => {
                        ScrollTrigger.create({
                            trigger: img,
                            start: "top center",
                            end: "bottom center",
                            onEnter: function () {
                                itemOnEnter(img)
                            },
                            onEnterBack: function () {
                                itemOnEnter(img)
                            },
                            onLeave: function () {
                                itemOnLeave(img)
                            },
                            onLeaveBack: function () {
                                itemOnLeave(img)
                            },
                            // markers: true
                        });
                    });
                }
            });

        });
    }

    // Identity gate
    if ($('.identity-list--item').exists()) {
        // let identity = document.querySelector('.identity-list');
        // let items = identity.querySelectorAll('.identity-list--item');

        $('.identity-list--item').each(function () {
            var $this = $(this);
            var videoElement = $this.find(".section--video__item")[0];
            let videoSrc = $this.find(".section--video__item").data('src');
            let videoReadyState;

            if (Hls.isSupported()) {
                var hls = new Hls();
                hls.loadSource(videoSrc);
                hls.attachMedia(videoElement);
                hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                    videoReadyState = 3;
                });
            } else {
                videoElement.src = videoSrc;
                videoElement.load();
                videoElement.addEventListener('loadeddata', (e) => {
                    videoReadyState = videoElement.readyState;
                });
            }

            let itemOnEnter = () => {
                $this.addClass('is-playing');
                videoElement.play();
            }
            let itemOnLeave = () => {
                $this.removeClass('is-playing');
                videoElement.pause();
            }
            if (deviceType() === "mobile" || deviceType() === "tablet") {
                if ($this.index() == 0) {
                    $this.addClass('is-playing');
                    videoElement.play();
                }
                var videoElementTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: $this[0],
                        start: "center 80%",
                        end: "center 10%",
                        // markers: true,
                        onEnter: function () {
                            itemOnEnter()
                        },
                        onEnterBack: function () {
                            itemOnEnter()
                        },
                        onLeave: itemOnLeave,
                        onLeaveBack: itemOnLeave,
                    }
                });
            } else {
                $this.hoverIntent({
                    over: itemOnEnter,
                    out: itemOnLeave
                });
            }
        });
    }

    // History timeline
    if ($('.history--timeline').exists()) {
        const yearLabel = document.querySelector(".year-label");

        var years = document.querySelector('.years');
        var yearsOptions = {
            asNavFor: '.years-content',
            groupCells: 3,
            cellAlign: 'left',
            cellSelector: '.item',
            pageDots: false
        };
        // groupCells at 768px
        if (matchMedia('screen and (min-width: 768px)').matches) {
            yearsOptions.groupCells = 5;
        }

        // groupCells at 1200px
        if (matchMedia('screen and (min-width: 1200px)').matches) {
            yearsOptions.groupCells = 7;
        }
        var yearsFlkty = new Flickity(years, yearsOptions);

        var yearsContent = document.querySelector('.years-content');
        var yearsContentFlkty = new Flickity(yearsContent, {
            cellSelector: '.item',
            draggable: false,
            fade: true,
            prevNextButtons: false,
            pageDots: false
        });

        var label = document.querySelector('.year-label');
        var yearLabelFlkty = new Flickity(label, {
            cellSelector: '.item',
            draggable: false,
            fade: true,
            pageDots: false,
            prevNextButtons: false
        });

        yearsContentFlkty.on('change', function (index) {
            // var current = parseInt(yearLabel.textContent);
            // var next = parseInt(years.querySelector('.is-nav-selected').textContent);
            // animateValue(yearLabel, current, next, 800);
            yearLabelFlkty.select(index, false, false)
        });

    }

    // Breadcrumbs
    if ($('.breadcrumbs').exists()) {
        let get_start = () => {
            return -1 * ((window.innerHeight / 100) * 90);
        }
        ScrollTrigger.create({
            start: "top " + get_start(),
            // end: 99999,
            // markers: true,
            toggleClass: {className: 'show', targets: '.breadcrumbs'}
        });
    }

    if ($('.events-slider').exists()) {
        const events = document.querySelector(".events-slider");

        var eventsFlkty = new Flickity(events, {
            autoPlay: 5000,
            cellAlign: 'left',
            cellSelector: '.item',
            draggable: false,
            fade: true,
            prevNextButtons: false,
            pageDots: false
        });
    }

    // Tabs
    if ($('.tabs').exists()) {
        $('.tabs').not('.modal-tabs').each(function () {
            makeTabs(this, true);
        });
    }

    // video carousel
    if ($('.video-carousel').exists()) {
        var videoCarousel = document.querySelector('.video-carousel');
        var itemsLength = videoCarousel.querySelectorAll('.item').length;

        var videoCarouselOptions = {
            groupCells: 2,
            cellAlign: 'center',
            cellSelector: '.item',
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true
        };
        // groupCells at 768px
        if (matchMedia('screen and (min-width: 768px)').matches) {
            videoCarouselOptions.groupCells = 3;
        }

        if (itemsLength > videoCarouselOptions.groupCells) {
            var videoCarouselFlkty = new Flickity(videoCarousel, videoCarouselOptions);
        }

        lightGallery($('.video-carousel')[0], {
            mode: 'lg-soft-zoom',
            selector: ".item--link[data-src]",
            download: false,
            counter: false,
            videoMaxWidth: "80%",
            getCaptionFromTitleOrAlt: false,
            youtubePlayerParams: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                controls: 1,
            },
            vimeoPlayerParams: {
                byline: 0,
                portrait: 0,
            },
            plugins: [lgVideo],
        });

    }

    // open video popup
    initVideoModal($('.btn-video'));

    // Modal Single image
    if ($('.image-zoom').exists()) {
        var imgzoomEl = $('.image-zoom');
        imgzoomEl.off('click');
        imgzoomEl.on('click', function (event) {
            event.preventDefault();
            var item = this;
            item.blur();

            spinner().create('art-loader', item);

            var image = $(this).data('src');
            var filesmodal = $('#modal-lightbox');
            filesmodal.find('.modal--image').append('<div class="image"><img src="' + image + '" /></div>');
            var img = filesmodal.find('.modal--image img');

            gsap.set(img, {scale: 1.1, autoAlpha: 0});

            let doModal = () => {
                filesmodal.modal({
                    blockerClass: "modal-lightbox"
                });

                filesmodal.on($.modal.AFTER_CLOSE, function (event, modal) {
                    modal.$elm.find('.modal--image .image').remove();
                });

                filesmodal.on($.modal.OPEN, function (event, modal) {
                    spinner().hide('art-loader');

                    setTimeout(function () {
                        gsap.to(img, {scale: 1, autoAlpha: 1, ease: "power1.inOut"})
                        $(item).find('#art-loader').remove()
                    }, 200)
                });
            }

            if (img[0].complete) {
                doModal();
            } else {
                img[0].addEventListener('load', doModal, false);
            }
        })
    }

    // Modal News Photogallery
    if ($('.photogallery').exists()) {
        var items = $('.photogallery .item[data-modal]');
        items.off('click');
        items.on('click', function (event) {
            event.preventDefault();
            var item = this;
            item.blur();

            spinner().create('art-loader', item);

            var image = $(this).data('modalImg');
            var content = $(this).find('.modal-content').html();

            var filesmodal = $($(this).data("modal"));
            filesmodal.find('.modal--image').append('<div class="image"><img src="' + image + '" /></div>');
            filesmodal.find('.modal--content').append('<div class="cont">' + content + '</div>');

            var img = filesmodal.find('.modal--image img');

            gsap.set(img, {scale: 1.1, autoAlpha: 0});

            let simpleBar;
            if (deviceType() !== "mobile") {
                simpleBar = new SimpleBar(filesmodal.find('.modal--content .cont')[0], {autoHide: false});
            }

            let doModal = () => {
                filesmodal.modal({
                    blockerClass: "modal-photogallery"
                });

                filesmodal.on($.modal.AFTER_CLOSE, function (event, modal) {
                    modal.$elm.find('.modal--image .image').remove();
                    modal.$elm.find('.modal--content .cont').remove();
                });

                filesmodal.on($.modal.OPEN, function (event, modal) {
                    if (modal.$elm.find('.modal--content .tabs').exists()) {
                        modal.$elm.find('.modal--content .tabs').each(function () {
                            makeTabs(this);
                        });
                    }

                    if (deviceType() !== "mobile") {
                        simpleBar.recalculate();
                    }

                    // spinner().hide();
                    spinner().hide('art-loader');
                    setTimeout(function () {
                        gsap.to(img, {scale: 1, autoAlpha: 1, ease: "power1.inOut"})
                        $(item).find('#art-loader').remove()
                    }, 200);
                });
            }

            if (img[0].complete) {
                doModal();
            } else {
                img[0].addEventListener('load', doModal, false);
            }
        });
    }

    // Modal Art Photogallery
    if ($('.art-photogallery').exists()) {
        let updateModalContent = function (item, filesmodal) {
            event.preventDefault();

            let $modalCont = filesmodal.find('.modal--content .cont');
            if ($('#page-loader').length) {
                spinner().show($('#page-loader')[0], 'page-loader');
            } else {
                spinner().create('page-loader', document.body);
            }

            let simpleBar = SimpleBar.instances.get($modalCont[0]);
            if (simpleBar) {
                simpleBar.unMount();
            }

            $modalCont.html('');

            $(item).find('.modal-content').clone(true).appendTo($modalCont);

            // open video popup
            initVideoModal($modalCont.find('.btn-video'));

            gsap.set('.modal-art-photogallery img', {scale: 1.1, autoAlpha: 0});

            if (myLazyLoad) {
                myLazyLoad.update();
            }

            initModalNavigation(item, filesmodal);

            if (deviceType() !== "mobile") {
                let simpleBar = new SimpleBar($modalCont[0], {autoHide: false});
            }

            setTimeout(function () {
                spinner().hide('page-loader');
            }, 250);

        }
        let initModalNavigation = function (item, filesmodal) {
            // calculate prev e next items
            let $prevItem = $(item).prev('.art-photogallery .item[data-modal]');
            let $nextItem = $(item).next('.art-photogallery .item[data-modal]');
            let $modalNavigation = filesmodal.find('.modal--content .modal-navigation');
            if ($modalNavigation.length) {
                let $modalNavPrev = $modalNavigation.find('.modal-navigation-prev span');
                if ($modalNavPrev.length) {
                    if ($prevItem.length) {
                        $modalNavPrev.text($prevItem.attr('data-title')).show();
                        $modalNavPrev.off('click').on('click', function () {
                            updateModalContent($prevItem, filesmodal);
                        });
                    } else {
                        $modalNavPrev.text('').hide();
                    }
                }

                let $modalNavNext = $modalNavigation.find('.modal-navigation-next span');
                if ($modalNavNext.length) {
                    if ($nextItem.length) {
                        $modalNavNext.text($nextItem.attr('data-title')).show();
                        $modalNavNext.off('click').on('click', function () {
                            updateModalContent($nextItem, filesmodal);
                        });
                    } else {
                        $modalNavNext.text('').hide();
                    }
                }
            }
        };

        var items = $('.art-photogallery .item[data-modal]');
        items.off('click').on('click', function (event) {
            event.preventDefault();
            const item = this;
            item.blur();

            spinner().create('art-loader', item);

            var filesmodal = $($(this).data("modal"));
            filesmodal.find('.modal--content').append('<div class="cont"></div>');

            $(this).find('.modal-content').clone(true).appendTo(filesmodal.find('.modal--content .cont'));

            initVideoModal(filesmodal.find('.modal--content .cont .btn-video'));

            gsap.set('.modal-art-photogallery img', {scale: 1.1, autoAlpha: 0});

            if (myLazyLoad) {
                myLazyLoad.update();
            }

            var img = filesmodal.find('.modal--content img');
            gsap.set(img, {scale: 1.1, autoAlpha: 0});

            let simpleBar;
            if (deviceType() !== "mobile") {
                simpleBar = new SimpleBar(filesmodal.find('.modal--content .cont')[0], {autoHide: false});
            }

            initModalNavigation(this, filesmodal);

            let doModal = () => {
                filesmodal.modal({
                    blockerClass: "modal-art-photogallery"
                });

                filesmodal.on($.modal.AFTER_CLOSE, function (event, modal) {
                    modal.$elm.find('.modal--content .cont').remove();
                });

                filesmodal.on($.modal.OPEN, function (event, modal) {
                    img[0].removeEventListener('load', doModal);

                    if (deviceType() !== "mobile") {
                        simpleBar.recalculate();
                    }

                    spinner().hide('art-loader');
                    setTimeout(function () {
                        gsap.to(img, {scale: 1, autoAlpha: 1, ease: "power1.inOut"})
                        $(item).find('#art-loader').remove()
                    }, 200);
                });
            }

            if (img[0].complete) {
                doModal();
            } else {
                img[0].removeEventListener('load', doModal);
                img[0].addEventListener('load', doModal, false);
            }

        });
    }

    // Open gallery from photogallery button
    if ($(".btn-gallery").exists()) {
        $(".btn-gallery").each(function () {
            var $this = $(this);
            var $lggallery = $("#" + $this.data("gallery"));

            lightGallery($lggallery[0], {
                mode: 'lg-soft-zoom',
                selector: "img",
                download: false,
                counter: false,
                getCaptionFromTitleOrAlt: false
            });

            $this.on('click', function (e) {
                e.preventDefault();
                $lggallery.find("img").first().trigger("click");
            });
        });
    }

    // Simple Lightgallery
    if ($("#lightgallery").exists()) {
        lightGallery($("#lightgallery")[0], {
            mode: 'lg-soft-zoom',
            selector: '.item',
            download: false,
            counter: false,
            getCaptionFromTitleOrAlt: false,
            zoom: true,
            infiniteZoom: false,
            mobileSettings: {
                controls: false,
                showCloseIcon: true
            },
            plugins: [lgZoom]
        });
    }

    // add this code
    Flickity.prototype._createResizeClass = function () {
        this.element.classList.add("flickity-resize");
    };
    Flickity.createMethods.push("_createResizeClass");
    var FlickityResize = Flickity.prototype.resize;
    if ($(".flickity-resize").exists()) {
        Flickity.prototype.resize = function () {
            var $this = this;
            $(".flickity-resize").each(function () {
                $this.element.classList.remove("flickity-resize");
                FlickityResize.call($this);
                $this.element.classList.add("flickity-resize");
            });
        }
    }

    // scrollto
    $('.scrollto').on('click', function () {
        var el = $(this).data('scrollto');
        if (!el) {
            var href = $(this).attr('href');
            if (href.startsWith("#"))
                el = href.slice(1);
        }
        if ($('#' + el)) {
            $("html,body").animate(
                {
                    scrollTop: $('#' + el).offset().top - 40,
                },
                400
            );
        }
    });

    // Ajax modal
    $('a[rel="ajax:modal"]').off('click');
    $('a[rel="ajax:modal"]').on('click', function (event) {
        event.preventDefault();
        this.blur();

        spinner().create('art-loader', document.querySelector('.main'));
        $('.main').find('#art-loader').addClass('fixed');

        $.ajax({
            url: $(this).attr("href"),
            success: function (newHTML, textStatus, jqXHR) {
                var myHtml = $(newHTML).find(".ajax-load");
                $(myHtml).appendTo("body");
                var filesmodal = $(myHtml).modal();
                filesmodal.on($.modal.OPEN, function (event, modal) {
                    let simpleBar;
                    if (deviceType() !== "mobile") {
                        simpleBar = new SimpleBar(modal.$elm.find('.scroller')[0], {});
                    }

                    spinner().hide('art-loader');
                    setTimeout(function () {
                        $('.main').find('#art-loader').remove()
                    }, 200)
                })
            }
        });
        return false;
    });

    // Inline modal
    if ($('.inline-modal[data-modal]').exists()) {
        $('.inline-modal[data-modal]').off('click');
        $('.inline-modal[data-modal]').on('click', function (event) {
            event.preventDefault();
            this.blur();
            var filesmodal = $($(this).data("modal"));
            filesmodal.modal();
        });
    }

    // Ajax modal fullscreen
    $('a[rel="ajax:modal-fullscreen"]').off('click').on('click', function (event) {
        if (event.cancelable) event.preventDefault();
        this.blur();

        spinner().create('art-loader', document.querySelector('.main'));
        $('.main').find('#art-loader').addClass('fixed light');

        $.ajax({
            url: $(this).attr("href"),
            success: function (newHTML, textStatus, jqXHR) {
                var myHtml = $(newHTML).find(".ajax-content-to-load");
                $(myHtml).appendTo("body");
                var filesmodal = $(myHtml).modal({modalClass: "modal-fullscreen"});
                filesmodal.on($.modal.OPEN, function (event, modal) {
                    spinner().hide('art-loader');
                    setTimeout(function () {
                        $('.main').find('#art-loader').remove()
                    }, 200)
                })

                filesmodal.on($.modal.CLOSE, function (event, modal) {
                    $(myHtml).remove();
                })

                $('body').trigger('ajax-content-loaded');
            }
        });
        return false;
    });

    // update analytics
    if (typeof analyticsUpdate === "function") {
        analyticsUpdate();
    }

    // *** Inizializza le tendine annate nella scheda prodotto
    wineDetail();

    // *** Inizializza reset pwd
    clubArea();

    // Divinea
    if ($('#divinea').exists()) {
        if (customElements.get('app-divinea')) {
            // already loaded prevent error: Failed to execute 'define' on 'CustomElementRegistry': this name has already been used with this registry
        } else {
            var $script = $('<script id="divinea" type="text/javascript" src="https://divinea-widget.web.app/app-divinea.js"></script>');
            $.ajax({
                url: $script.attr('src'),
                cache: true,
                dataType: 'script',
                success: function () {
                    $script.trigger('load');
                }
            });
        }
    }
}

// BARBA JS
// start script
barba.use(barbaCss);

// define a global hook
barba.hooks.once((data) => {
    // this hook will be called for each transitions
    // spinner().show();
    // $('.page-transition').addClass('show');
    navbar();
    myapp();

    // Remove appended div to modal after close
    $(document).on($.modal.AFTER_CLOSE, function (event, modal) {
        $(".ajax-load.modal").remove();
    });

    // Analytics update
    $(document).on($.modal.OPEN, function (event, modal) {
        if (typeof analyticsUpdate === "function") {
            analyticsUpdate();
        }
        $(modal.$anchor).find(".close-modal").attr("data-barba-prevent", "self");
    });
    $(document).on($.modal.CLOSE, function (event, modal) {
        if (typeof analyticsUpdate === "function") {
            analyticsUpdate();
        }
    });

    // $("#spinner").removeClass("default");
    // setTimeout(function() {
    //   $("#spinner");.remove()
    // }, 800);

    $(".page-transition").removeClass("show");
});


barba.hooks.enter((data) => {
    $.ajax({
        url: data.next.url.href,
        success: function (newHTML, textStatus, jqXHR) {
            // Meta update
            var headTags = [
                "meta[name='keywords']",
                "meta[name='description']",
                "meta[property^='og']",
                "meta[name^='twitter']",
                "meta[itemprop]",
                "link[itemprop]",
                "link[rel='prev']",
                "link[rel='next']",
                "link[rel='canonical']",
            ].join(",");
            $("head").find(headTags).remove();
            $(newHTML).find(headTags).appendTo("head");

            // Section placeholder Change
            var newplaceholdersection = $(newHTML)
                .find(".placeholder-section")
                .html();
            $(".navbar .placeholder-section").html(newplaceholdersection);

            // Menu Change
            var newmenu = $(newHTML).find(".navbar__collapse").html();
            $(".navbar .navbar__collapse").html(newmenu);

            // Menu Change Sx
            var newmenuPreviewSx = $(newHTML).find(".navbar__sx .menu-preview").html();
            $(".navbar__sx .menu-preview").html(newmenuPreviewSx);
            // Menu Change Dx
            var newmenuPreviewDx = $(newHTML).find(".navbar__dx .menu-preview").html();
            $(".navbar__dx .menu-preview").html(newmenuPreviewDx);

            // script on page variables
            let js = data.next.container.querySelectorAll('main script');
            if (js != null) {
                js.forEach((item) => {
                    eval(item.innerHTML);
                });
            }

            myapp();
        },
        error: function (xhr, ajaxOptions, thrownError) {
            alert(xhr.status)
            alert(xhr.statusText)
            // alert(thrownError)
        },
        complete: function () {
        },
    });
});

barba.hooks.beforeLeave((data) => {
    // spinner().show();
    $(".page-transition").addClass("animIn");
})

barba.hooks.leave((data) => {
    // this hook will be called for each transitions
    $.modal.close();
});

barba.hooks.beforeEnter((data) => {
    // $('.navbar').fadeOut()
    $(".wrapper").removeAttr("style");
    $(".main").removeAttr("style");

    $("body").removeClass("navbar--opened");

    $("html,body").animate({
        scrollTop: 0,
    }, 0);

    $(".navbar").removeClass("out-stage, on-stage--ico-menu, tween");

    ScrollTrigger.getAll().forEach(t => {
        t.kill()
    });
});

barba.hooks.afterEnter((data) => {

    if ($(".thom-form__recaptcha").length != 0) {
        recaptchaLoad();
    }

    if ($(".mtcaptcha").length != 0) {
        mt_jsloadedcb();
    }

    // spinner().hide();
    $(".navbar").addClass("tween");
    $(".page-transition").removeClass("animIn");

    var hash = $(location).attr('hash');
    if (hash) {
        $("html,body").animate({
            scrollTop: $(hash).offset().top,
        }, 400);
    }

    // 1. Cerca lo script della dichiarazione nel nuovo container
    const cookieScript = data.next.container.querySelector('#CookieDeclaration');
    if (cookieScript) {
        // 2. Se lo script esiste, lo rimuoviamo e lo reinseriamo
        // Questo è il modo più affidabile per forzare il rendering dei dati AJAX
        const newScript = document.createElement('script');

        // Copia tutti gli attributi necessari
        newScript.src = cookieScript.src;
        newScript.id = 'CookieDeclaration';
        newScript.async = true;
        newScript.type = 'text/javascript';

        // Sostituisci il vecchio segnaposto con lo script attivo
        cookieScript.parentNode.replaceChild(newScript, cookieScript);

        // 3. Opzionale: Se il banner del consenso dovesse sparire, forza il re-init
        if (window.Cookiebot && typeof Cookiebot.runScripts === 'function') {
            Cookiebot.runScripts();
        }
    }
});

// Basic default transition, with no rules and minimal hooks…
barba.init({
    timeout: 5000,
    cacheIgnore: true,
    prefetchIgnore: true,
    debug: false
});

// A.Scapin: funzione che recupera la nazione di provenienza in base all'IP
window.getIp = function (callback) {
    // TOKEN: 548d42fc727819 (da ipinfo.io registrato con account Google alessandro.scapin@thehouseofmouse.net)
    fetch('https://ipinfo.io/json?token=548d42fc727819', {headers: {'Accept': 'application/json'}})
        .then((resp) => resp.json())
        .catch(() => {
            return {
                country: 'it',//default country
            };
        })
        .then((resp) => callback(resp.country));
}

window.autocomplete = 'ciao';

// Visite cantina
cellarVisit();
// *******************************************************

// A.Scapin: funzione che inizializza il form "Premio Scultura"
window.initialize_scaw = function (validator_url, post_page_url) {
    //TODO: verificare funzionamento!
    //console.log('****************** window.initialize_scaw() ***********************');

    //VIP: FORM SUBMIT DEL VISITA LA CANTINA
    $('#award-form').submit(function (event) {
        event.preventDefault();

        $('.page-loader').addClass('show'); // mostra loader

        // rimuove tutte le indicazioni di errore
        $('.thom-form__error').html('');
        $('#award-form').find('.field-error').removeClass("field-error");

        // questi devo validarli prima (o comunque separatamente)
        var isOkToGo = true;

        if (isOkToGo) {
            var $form = $('#award-form');

            // Definiamo la funzione di invio AJAX per non ripeterla
            var proceedToAjax = function() {
                $('.page-loader').addClass('show');
                $.ajax({
                    type: 'POST',
                    url: validator_url,
                    data: $form.serialize(),
                    success: function (response) {
                        if (!response.status) {
                            $('.page-loader').removeClass('show');
                            $form.find('button[type="submit"]').prop('disabled', false);
                            $('.thom-form__error').html(response.message).fadeIn();
                            $('#' + response.field).addClass('field-error');
                            return false;
                        }
                        // All OK go!
                        // prima: $.redirect(url, $form.serialize()) inviava un campo per carattere (vuole un oggetto, non una stringa)
                        postFormTo(post_page_url, $form[0]);
                    },
                    error: function() {
                        $('.page-loader').removeClass('show');
                        $form.find('button[type="submit"]').prop('disabled', false);
                    }
                });
            };

            // Il captcha è sempre obbligatorio: il token viene verificato lato server
            window.executeRecaptchaProcess($form[0], function(token) {
                proceedToAjax();
            });
        }
    });
}
// *******************************************************


// Mappe
function initEnogeaMaps() {
    if ($('.pano-viewer--map').length || $('.pano-viewer').length) {
        mapEnogea();
    }
}

initEnogeaMaps();
$('body').on('ajax-content-loaded', function () {
    initEnogeaMaps();
});
// *********************************************************


// Club Area
clubArea();
//* ---- fine variabili e funzioni necessarie alla ricerca dell'Area Club

// Newsletter
newsletter();
//* --- fine variabili e funzioni per controllare il form iscrizione Newsletter